module.exports = __webpack_public_path__ + "static/img/logo.27496e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 563
// module chunks = 1